module.exports = __webpack_public_path__ + "h5/img/returnimg.169572e2.png";